import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import InvoiceForm from '../components/InvoiceForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';
import { useCreateInvoiceHandler } from '../dataHandlers/createInvoiceHandler';
import { generalPublicDetails } from '../../../utils/generalPublicDetails';

export default function CreateInvoicePage() {
  useDocumentTitle('Invoice Form');
  const navigate = useNavigate();
  const location = useLocation();

  const onInvoiceCreated = ({ payload }) => {
    if (payload.status === 'draft') {
      navigate('/drafts?tab=invoices');
    } else {
      navigate('/documents?tab=invoices');
    }
  };

  const { onSubmit, error } = useCreateInvoiceHandler({ onSuccess: onInvoiceCreated });

  const document = location.state?.document;

  const onSaveAsEInv = async (data) => {
    const payload = {
      ...data,
      status: 'active',
      billed_to: data?.billed_to || {},
    };

    await onSubmit(payload, data.status);
  };
  const onSaveAsDraft = async (data) => {
    const payload = {
      ...data,
      status: 'draft',
      billed_to: data.billed_to ? data.billed_to : generalPublicDetails,
    };
    await onSubmit(payload, data.status);
  };

  const onCancel = async () => {
    navigate(location.state?.from || '/documents?tab=invoices');
  };

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <InvoiceForm
        initialData={document || {}}
        onSubmit={onSaveAsEInv}
        onCancel={onCancel}
        onSaveDraft={onSaveAsDraft}
        apiErrors={error}
        isDraftButtonEnabled={location.state?.isDraftButtonEnabled}
      />
    </Stack>
  );
}
